import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation, Trans } from 'react-i18next'
import { honeybadger } from '../../honeybadger'

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as userActions from '../../actions/userActions'
import * as familyActions from '../../actions/familyActions'
import * as communitiesActions from '../../actions/communitiesActions'
import * as announcementsActions from '../../actions/announcementsActions'
import * as activityActions from '../../actions/activityActions'
import _ from 'lodash'
import { Wizard, Steps, Step } from 'react-albus'
import { Tab, Tabs, TabList, TabPanel } from '../common/Tabs'
import moment from 'moment'
import SearchInput, { createFilter } from 'react-search-input'
import Placeholder from '../common/Placeholder'
import Loader from '../common/loader/legacy-loaders/Op36Loader'
import StudentModal from './StudentModal'
import PreviewModal from './PreviewModal'
import ValidationModal from '../common/ValidationModal'
import TextInput from '../common/form/TextInput'
import TextAreaInput from '../common/form/TextAreaInput'
import MyStatefulEditor from '../common/form/MyStatefulEditor'
import { MAX_EMAIL_LIMIT } from '../../misc/Constants'

// Assets
import '../../assets/styles/components/annoucements/CampaignPage.scss'
import { ReactComponent as AnnouncementIcon } from '../../assets/images/common/icons/announcement-icon.svg'
import coachLogo from '../../assets/images/logos/coach_logo.png'

import defaultProfilePic from '../../assets/images/default_profile.png'
import { withRouting } from '../common/hooks'

const PROGRAM_KEYS_TO_FILTERS = ['name']
const FAMILY_KEYS_TO_FILTERS = ['name', 'email']
const STUDENT_KEYS_TO_FILTERS = ['first_name', 'last_name', 'username']

const EMAIL_TEMPLATES = {
  0: { subjectKey: null, bodyKey: null },
  1: { subjectKey: 'announcements.campaign.templates.subject1', bodyKey: 'announcements.campaign.templates.body1' },
  2: { subjectKey: 'announcements.campaign.templates.subject2', bodyKey: 'announcements.campaign.templates.body2' },
  3: { subjectKey: 'announcements.campaign.templates.subject3', bodyKey: 'announcements.campaign.templates.body3' },
  4: { subjectKey: 'announcements.campaign.templates.subject4', bodyKey: 'announcements.campaign.templates.body4' },
  5: { subjectKey: 'announcements.campaign.templates.subject5', bodyKey: 'announcements.campaign.templates.body5' },
  6: { subjectKey: 'announcements.campaign.templates.subject6', bodyKey: 'announcements.campaign.templates.body6' },
}

class Campaign extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.wizard = React.createRef()
    // const isSafari =
    //   navigator.userAgent.indexOf("Safari") !== -1 &&
    //   navigator.userAgent.indexOf("Chrome") === -1;

    this.state = {
      checked: this.props.checked,
      showModal: false,
      message: '',
      pushMessage: '',
      pushMessageLength: 0,
      subject: '',
      searchProgram: '',
      searchFamily: '',
      searchStudent: '',
      templateValue: '',
      programLoader: false,
      familyLoader: false,
      studentLoader: false,
      emailLoader: false,
      students: [],
      recipients: [],
      isFamily: false,
      // isSafari: isSafari,
      isTemplate: false,
      isEmail: true,
      selectedAllFamily: false,
      showValidationModal: false,
      validationSuccess: false,
      validationMessage: '',
      courses: [],
      messageTypeSelected: 'email',
      activeProgramsSelected: true,
    }
  }

  componentDidMount() {
    this.fetchInitialProps()
    this.applySmartToggle()
  }

  componentDidUpdate(prevProps) {
    const oldSmartToggle = prevProps.location?.state?.smartToggle
    const newSmartToggle = this.props.location?.state?.smartToggle

    if (oldSmartToggle === newSmartToggle) {
      return
    }

    this.applySmartToggle()
    this.wizard.current.push('Recipients')
  }

  applySmartToggle = () => {
    const { location } = this.props

    if (_.isEmpty(location.state) || !['email', 'push'].includes(location.state.smartToggle)) {
      return
    }

    const students = location.state.students

    if (students.some(s => !('familyAdminsEmails' in s))) {
      honeybadger.notify(
        'Students from event do not have the "familyAdminsEmails" attribute',
        {
          name: 'Custom log - missing "familyAdminsEmails" attribute',
          context: { students },
        }
      )
    }

    const recipientList = location.state.students.map(s => {
      const emails = s.email && !s.familyAdminsEmails.includes(s.email) ? [...s.familyAdminsEmails, s.email] : s.familyAdminsEmails
      const copyStudent = { ...s, emails: emails }
      return copyStudent
    })

    if (recipientList.some(r => !('emails' in r))) {
      honeybadger.notify(
        'Students from event do not have the "emails" attribute',
        {
          name: 'Custom log - missing "emails" attribute',
          context: { recipientList },
        }
      )
    }

    this.setState({
      messageTypeSelected: location.state.smartToggle,
      isEmail: true,
      recipients: recipientList || [],
      courses: [],
    })
  }

  fetchInitialProps = () => {
    this.setState({ programLoader: true })
    this.props.user_actions
      .getAnnouncementCourses(this.props.user.communities[0].id)
      .then(() => {
        this.setState({ programLoader: false })
      })

    this.setState({ familyLoader: true })
    this.props.family_actions
      .getFamilies(this.props.user.communities[0].id)
      .then(() => {
        this.setState({ familyLoader: false })
      })

    this.setState({ studentLoader: true })
    this.props.community_actions
      .getAllStudents(this.props.user.communities[0].id)
      .then(() => {
        this.setState({ studentLoader: false })
      })
  }

  handleStatefulEditorChange = (htmlString) => {
    this.setState({
      message: htmlString,
    })
  }

  onChangePushMessage = (event) => {
    this.setState({
      pushMessage: event.target.value,
      pushMessageLength: event.target.value.length,
    })
  }

  onChangeSubject = (event) => {
    this.setState({ subject: event.target.value })
  }

  onChangeMessage = (event) => {
    this.setState({ message: event.target.value })
  }

  onTemplateChange = (event) => {
    const { t } = this.props
    const templateId = parseInt(event.target.value)
    const { subjectKey, bodyKey } = EMAIL_TEMPLATES[templateId]
    let subject = subjectKey ? t(subjectKey) : ''

    if (templateId === 1) {
      subject = this.props.user?.communities[0]?.name + subject
    }

    this.setState(
      {
        subject: subject,
        message: bodyKey ? t(bodyKey) : '',
        templateValue: templateId,
        isTemplate: true,
      },
      () => {
        this.setState({
          isTemplate: false,
        })
      }
    )
  }

  toggleSelectedAllFamily = () => {
    this.setState(
      {
        selectedAllFamily: !this.state.selectedAllFamily,
      },
      () => {
        if (this.state.selectedAllFamily) {
          const recipients = [...this.state.recipients]
          this.props.families.map((family) => {
            const familyAdminsEmails = family.users.filter(user => user.family_admin).map(user => user.email)
            if (family.users.length === 1) {
              recipients.push(family.users[0])
            } else {
              family.users.filter(user => !user.family_admin).map((user) => {
                const userCopy = { ...user }
                userCopy.emails = userCopy.email ? [...familyAdminsEmails, userCopy.email] : familyAdminsEmails
                if (recipients.length > 0) {
                  const foundIndex = recipients.findIndex(
                    (recipient) => recipient.id === userCopy.id
                  )
                  if (foundIndex > -1) {
                    recipients[foundIndex] = userCopy
                  } else {
                    recipients.push(userCopy)
                  }
                } else {
                  recipients.push(userCopy)
                }
              })
            }
          })

          this.setState({
            recipients: recipients,
          })
        } else if (!this.state.selectedAllFamily) {
          this.setState({
            recipients: [],
            courses: [],
          })
        }
      }
    )
  }

  isEmail = (index) => {
    if (index === 0) {
      this.setState({
        isEmail: true,
      })
    } else if (index === 1) {
      this.setState({
        isEmail: false,
      })
    }
  }

  messageTypeSelector = (type) => {
    if (type === 'email') {
      this.setState({
        messageTypeSelected: 'email',
        isEmail: true,
      })
    } else if (type === 'push') {
      this.setState({
        messageTypeSelected: 'push',
        isEmail: false,
      })
    }
  }

  sendPressed = () => {
    const { t } = this.props
    if (this.state.isEmail) {
      if (
        this.state.subject === '' &&
        this.state.message === '<p><br></p>' &&
        this.state.recipients.length > 0
      ) {
        this.toggleValidationModal(
          false,
          t('announcements.campaign.validationSubjectMessage')
        )
      } else if (
        this.state.subject === '' &&
        this.state.message === '' &&
        this.state.recipients.length > 0
      ) {
        this.toggleValidationModal(
          false,
          t('announcements.campaign.validationSubjectMessage')
        )
      } else if (
        this.state.subject === '' &&
        this.state.message !== '' &&
        this.state.recipients.length > 0
      ) {
        this.toggleValidationModal(
          false,
          t('announcements.campaign.validationSubject')
        )
      } else if (
        (this.state.subject !== '' &&
          this.state.message === '' &&
          this.state.recipients.length > 0) ||
        this.state.message === '<p><br></p>'
      ) {
        this.toggleValidationModal(
          false,
          t('announcements.campaign.validationMessage')
        )
      } else {
        this.togglePreviewModal()
      }
    } else if (!this.state.isEmail) {
      if (this.state.pushMessage === '' && this.state.courses.length > 0) {
        this.toggleValidationModal(
          false,
          t('announcements.campaign.validationAnnouncementMessage')
        )
      } else {
        this.togglePreviewModal()
      }
    }
  }

  toggleModal = (students, isFamily) => {
    this.grabStudents(students, isFamily)
    this.setState({ showModal: true })
  }

  togglePreviewModal = () => {
    this.setState({ showPreviewModal: true })
  }

  toggleValidationModal = (success, message) => {
    this.setState({
      showValidationModal: true,
      validationMessage: message,
      validationSuccess: success,
    })
  }

  closeValidationModal = () => {
    if (this.state.validationSuccess) {
      this.props.navigate('/announcements')
    }

    this.setState({
      showValidationModal: false,
    })
  }

  closeModal = () => {
    this.setState({ showModal: false })
  }

  closePreviewModal = () => {
    this.setState({ showPreviewModal: false })
  }

  createMarkup = () => ({ __html: this.state.message })

  renderEditor = () =>
    (
      <MyStatefulEditor
        name='content'
        content={this.state.message}
        onChange={this.handleStatefulEditorChange}
        isTemplate={this.state.isTemplate}
      />
    )


  sendMessage = () => {
    const { t } = this.props
    this.setState({
      emailLoader: true,
    })
    this.props.announcement_actions
      .postWebEmail(this.state, this.props.user?.communities?.[0]?.id)
      .then(() => {
        this.toggleValidationModal(
          true,
          t('announcements.campaign.messageQueued')
        )
        this.closePreviewModal()
        this.setState({ emailLoader: false })
      }
      )
      .catch(() => {
        this.toggleValidationModal(
          false,
          t('common.somethingWentWrong')
        )
        this.setState({
          createAnnouncementLoader: false,
          emailLoader: false,
        })
      })
  }

  resetState = () => {
    this.setState({
      searchProgram: '',
      searchFamily: '',
      searchStudent: '',
      programLoader: false,
      familyLoader: false,
      studentLoader: false,
    })
  }

  changeType = (previous) => {
    let messageType = ''
    if (this.state.messageTypeSelected === 'push') {
      messageType = 'email'
    }
    if (this.state.messageTypeSelected === 'email') {
      messageType = 'push'
    }
    this.setState(
      {
        isEmail: !this.state.isEmail,
        messageTypeSelected: messageType,
        recipients: [],
        courses: [],
      },
      () => {
        previous()
      }
    )
  }

  loadTabs = (index) => {
    this.resetState()
    if (this.props.courses.length === 0 && index === 0) {
      this.setState({ programLoader: true })
      this.props.user_actions
        .getAnnouncementCourses(this.props.user.communities[0].id)
        .then(() => {
          this.setState({ programLoader: false })
        })
    } else if (this.props.families.length === 0 && index === 1) {
      this.setState({ familyLoader: true })
      this.props.family_actions
        .getFamilies(this.props.user.communities[0].id)
        .then(() => {
          this.setState({ familyLoader: false })
        })
    } else if (this.props.community_students.length === 0 && index === 2) {
      this.setState({ studentLoader: true })
      this.props.community_actions
        .getAllStudents(this.props.user.communities[0].id)
        .then(() => {
          this.setState({ studentLoader: false })
        })
    }
  }

  grabStudents = (students, isFamily) => {
    this.setState(
      {
        students: [],
        isFamily: isFamily,
      },
      () => {
        const studentArray = [...this.state.students]
        if (isFamily) {
          students.map((student) => {
            if (!student.family_admin) {
              studentArray.push(student)
            } else {
              return null
            }
          })
        } else {
          students.map((student) => {
            studentArray.push(student.user)
          })
        }

        this.setState({
          students: studentArray,
        })
      }
    )
  }

  searchPrograms = (term) => {
    this.setState({ searchProgram: term })
  }

  searchFamilies = (term) => {
    this.setState({ searchFamily: term })
  }

  searchStudents = (term) => {
    this.setState({ searchStudent: term })
  }

  calculateStudentCount = (students) => {
    let studentCount = 0
    students.map((student) => {
      if (!student.family_admin) {
        studentCount += 1
      }
    })

    return studentCount
  }

  deleteRecipient = (recipient) => {
    const recipientList = [...this.state.recipients]
    const courses = [...this.state.courses]
    const foundIndex = recipientList.findIndex(
      (user) => user.id === recipient.id
    )
    const foundCourseIndex = courses.findIndex(
      (course) => course.id === recipient.id
    )

    if (foundIndex !== -1) {
      recipientList.splice(foundIndex, 1)
    }

    if (foundCourseIndex !== -1) {
      courses.splice(foundCourseIndex, 1)
    }

    if (this.state.messageTypeSelected === 'push') {
      this.setState({
        recipients: recipientList,
        courses: courses,
      })
    } else {
      this.setState({
        courses: [],
        recipients: recipientList,
      })
    }
  }

  addRecipientsByProgram = (course) => {
    const recipientList = [...this.state.recipients]
    const courses = [...this.state.courses]

    if (this.state.messageTypeSelected === 'email') {
      courses.push(course)
      course.enrollments.map((enrollment) => {
        const student = enrollment.user.family.users.find(user => user.id === enrollment.user_id)
        const familyAdminsEmails = enrollment.user.family.users.filter(user => user.family_admin && user.id !== student.id).map(user => user.email)
        const copyStudent = { ...student }
        copyStudent.emails = copyStudent.email ? [...familyAdminsEmails, copyStudent.email] : familyAdminsEmails
        if (recipientList.length > 0) {
          const foundIndex = recipientList.findIndex(
            (recipient) => recipient.id === copyStudent.id
          )
          if (foundIndex > -1) {
            recipientList[foundIndex] = copyStudent
          } else {
            recipientList.push(copyStudent)
          }
        } else {
          recipientList.push(copyStudent)
        }
      })
    } else {
      if (courses.length > 0) {
        const foundIndex = courses.findIndex(
          (c) => c.id === course.id
        )
        if (foundIndex > -1) {
          courses[foundIndex] = course
        } else {
          courses.push(course)
        }
      } else {
        courses.push(course)
      }
    }

    this.setState({
      recipients: recipientList,
      courses: courses,
    })
  }

  addRecipientsByFamily = (recipients) => {
    const recipientList = [...this.state.recipients]
    const familyAdminsEmails = recipients.filter(user => user.family_admin).map(user => user.email)
    if (recipients.length === 1) {
      recipientList.push(recipients[0])
    } else {
      recipients.filter(user => !user.family_admin).map((user) => {
        const userCopy = { ...user }
        userCopy.emails = userCopy.email ? [...familyAdminsEmails, userCopy.email] : familyAdminsEmails
        if (recipientList.length > 0) {
          const foundIndex = recipientList.findIndex(
            (recipient) => recipient.id === userCopy.id
          )
          if (foundIndex > -1) {
            recipientList[foundIndex] = userCopy
          } else {
            recipientList.push(userCopy)
          }
        } else {
          recipientList.push(userCopy)
        }
      })
    }

    this.setState({
      recipients: recipientList,
    })
  }

  addRecipientByStudent = (recipient) => {
    const recipientList = [...this.state.recipients]

    if (recipient.family_admin) {
      recipientList.push(recipient)
    } else {
      const familyAdminsEmails = recipient.family.users.filter(user => user.family_admin).map(user => user.email)
      const userCopy = { ...recipient }
      userCopy.emails = userCopy.email ? [...familyAdminsEmails, userCopy.email] : familyAdminsEmails
      if (recipientList.length > 0) {
        const foundIndex = recipientList.findIndex(
          (recipient) => recipient.id === userCopy.id
        )
        if (foundIndex > -1) {
          recipientList[foundIndex] = userCopy
        } else {
          recipientList.push(userCopy)
        }
      } else {
        recipientList.push(userCopy)
      }
    }

    this.setState({
      recipients: recipientList,
    })
  }

  navigateToFeedAnnouncements = () => {
    this.props.navigate('/dashboard/home', { state: { openModal: true } })
  }

  displayRecipients = () => {
    const { t } = this.props
    if (this.state.messageTypeSelected === 'email') {
      return this.state.recipients.map((user, index) => (
        <div className='border-bottom p-1 w-100 my-1' key={`recipient-${index}`}>
          <div className='row'>
            <div className='col-1 d-flex justify-content-center align-items-center'>
              <i className='fas fa text-success p-1 fa-check-circle' />
            </div>
            <div className='col-10 pl-0 pr-0'>
              <h6 className='my-0'>{`${user.first_name || user.firstName} ${user.last_name || user.lastName}`}</h6>
              <small className='my-0'>{`${
                user.emails ? user.emails.join(', ') : user.email
              }`}</small>
            </div>
            <div
              aria-hidden='true'
              className='col-1 d-flex align-items-center'
              onClick={() => this.deleteRecipient(user, index)}
            >
              <i className='fas fa p-1 fa-minus-circle recipient-delete-icon' />
            </div>
          </div>
        </div>
      ))
    } else {
      return this.state.courses.map((course, index) => {
        if (course.enrollments.length > 0) {
          return (
            <div
              className='card p-2 w-100 my-3 d-flex justify-content-between flex-row animated fadeIn'
              key={course.id}
            >
              <div>
                <h5>{course.name}</h5>
                <small>{`${moment(course.start_date).format(
                  'MM-DD-YYYY'
                )} - ${moment(course.end_date).format('MM-DD-YYYY')}`}</small>
                <small>
                  <button
                    className='btn-link no-bg-text-btn text-primary ml-2'
                    onClick={() => this.toggleModal(course.enrollments, false)}
                    disabled={course.enrollments.length === 0}
                  >
                    {t('announcements.campaign.studentCount', { count: course.enrollments.length })}{' '}
                  </button>
                </small>
              </div>
              <button
                className='btn add-recipient-button'
                type='submit'
                onClick={() => this.deleteRecipient(course, index)}
              >
                <i
                  className='fa fa-minus-circle recipient-delete-icon'
                  aria-hidden='true'
                />
              </button>
            </div>
          )
        } else {
          return null
        }
      })
    }
  }

  displayPrograms = () => {
    const { t } = this.props
    if (this.state.programLoader) {
      return (
        <div className='' style={{ marginTop: '50px', width: '100%' }}>
          <Loader message={t('announcements.campaign.loadingClasses')} />
        </div>
      )
    }
    if (this.props.courses) {
      const filteredPrograms = this.props.courses.filter(
        createFilter(this.state.searchProgram, PROGRAM_KEYS_TO_FILTERS)
      )
      if (filteredPrograms.length === 0 && this.props.courses.length > 0) {
        return (
          <Placeholder
            title={t('announcements.campaign.noResultsFound')}
            icon={'fa-search'}
            subtext1={t('announcements.campaign.searchAgainClass')}
          />
        )
      }
      if (this.props.courses.length === 0) {
        return (
          <Placeholder
            title={t('announcements.campaign.noCoursesAvailable')}
            icon={'fa-clipboard'}
            subtext1={t('announcements.campaign.goToClassesToStart')}
          />
        )
      }

      const selectedPrograms = this.state.activeProgramsSelected
        ? filteredPrograms.sort((p1, p2) => ((new Date(p1.start_date) - new Date(p2.start_date)) || (new Date(p1.end_date) - new Date(p2.end_date))))
          .filter((program) => !program.is_completed)
        : filteredPrograms.sort((p1, p2) => ((new Date(p2.end_date) - new Date(p1.end_date)) || (new Date(p2.start_date) - new Date(p1.start_date))))
          .filter((program) => program.is_completed)
      return selectedPrograms.map((course) => {
        if (course.enrollments.length > 0) {
          return (
            <div
              className='border-bottom p-2 w-100 my-3 d-flex justify-content-between flex-row animated fadeIn'
              key={course.id}
            >
              <div>
                <h5>{course.name}</h5>
                <small>{`${moment(course.start_date).format(
                  'MM-DD-YYYY'
                )} - ${moment(course.end_date).format('MM-DD-YYYY')}`}</small>
                <small>
                  <button
                    className='btn-link no-bg-text-btn text-primary ml-2'
                    onClick={() => this.toggleModal(course.enrollments, false)}
                    disabled={course.enrollments.length === 0}
                  >
                    {t('announcements.campaign.studentCount', { count: course.enrollments.length })}{' '}
                  </button>
                </small>
              </div>
              <button
                className='btn add-recipient-button'
                type='submit'
                onClick={() => this.addRecipientsByProgram(course)}
              >
                <i
                  className='fa fa-plus add-recipient-icon'
                  aria-hidden='true'
                />
              </button>
            </div>
          )
        } else {
          return null
        }
      })
    }
  }

  displayFamilies = () => {
    const { t } = this.props
    if (this.state.familyLoader) {
      return (
        <div
          className=''
          style={{ marginTop: '-32%', marginBottom: '50px', width: '100%' }}
        >
          <Loader message={t('announcements.campaign.loadingFamilies')} />
        </div>
      )
    }
    if (this.props.families) {
      const filteredFamilies = this.props.families.filter(
        createFilter(this.state.searchFamily, FAMILY_KEYS_TO_FILTERS)
      )
      if (this.props.families.length === 0) {
        return (
          <Placeholder
            title={t('announcements.campaign.noFamiliesAvailable')}
            icon={'fa-users'}
            subtext1={t('announcements.campaign.goToFamiliesToStart')}
          />
        )
      }
      if (filteredFamilies.length === 0 && this.props.families.length > 0) {
        return (
          <Placeholder
            title={t('announcements.campaign.noResultsFound')}
            icon={'fa-search'}
            subtext1={t('announcements.campaign.searchAgainFamily')}
          />
        )
      }
      return filteredFamilies.map((family) => (
        <div
          className='border-bottom p-2 w-100 my-3 d-flex justify-content-between flex-row animated fadeIn'
          key={family.id}
        >
          <div>
            <h5>{family.name}</h5>
            <small>
              <button
                className='btn-link no-bg-text-btn text-primary'
                onClick={() => this.toggleModal(family.users, true)}
                disabled={family.users.length <= 1}
              >
                {t('announcements.campaign.studentCount', { count: this.calculateStudentCount(family.users) })}
              </button>
            </small>
          </div>
          <button
            className='btn add-recipient-button'
            type='submit'
            onClick={() => this.addRecipientsByFamily(family.users)}
          >
            <i className='fa fa-plus add-recipient-icon' aria-hidden='true' />
          </button>
        </div>
      ))
    }
  }

  displayStudents = () => {
    const { t } = this.props
    if (this.state.studentLoader) {
      return (
        <div
          className=''
          style={{ marginTop: '-32%', marginBottom: '50px', width: '100%' }}
        >
          <Loader message={t('announcements.campaign.loadingStudents')} />
        </div>
      )
    }
    if (this.props.community_students) {
      const filteredStudents = this.props.community_students.filter(
        createFilter(this.state.searchStudent, STUDENT_KEYS_TO_FILTERS)
      )
      if (this.props.community_students.length === 0) {
        return (
          <Placeholder
            title={t('announcements.campaign.noStudentsAvailable')}
            icon={'fa-user'}
            subtext1={t('announcements.campaign.goToFamilies')}
            subtext2={t('announcements.campaign.clickOnFamily')}
            subtext3={t('announcements.campaign.startAddingStudents')}
          />
        )
      }
      if (
        filteredStudents.length === 0 &&
        this.props.community_students.length > 0
      ) {
        return (
          <Placeholder
            title={t('announcements.campaign.noResultsFound')}
            icon={'fa-search'}
            subtext1={t('announcements.campaign.searchAgainStudent')}
          />
        )
      }
      return filteredStudents.map((student) => (
        <div
          className='border-bottom p-2 w-100 my-3 d-flex justify-content-between flex-row animated fadeIn'
          key={student.id}
        >
          <div className='row w-100'>
            <div className='col-2 align-items-center'>
              <div className='round-image-wrapper'>
                <img
                  className='round-image'
                  src={
                    student.avatar
                      ? student.avatar.file_url
                      : defaultProfilePic
                  }
                  alt={t('announcements.campaign.studentAvatarAlt')}
                />
              </div>
            </div>
            <div className='col-9'>
              <h5>{`${student.first_name} ${student.last_name}`}</h5>
              <small>
                {student.username
                  ? `${student.username}`
                  : `${student.email}`}
              </small>
            </div>
            <div className='col-1 align-items-flex-end d-flex justify-content-center flex-column'>
              <button
                className='btn add-recipient-button'
                type='submit'
                onClick={() =>
                  this.addRecipientByStudent(student)
                }
              >
                <i
                  className='fa fa-plus add-recipient-icon'
                  aria-hidden='true'
                />
              </button>
            </div>
          </div>
        </div>
      ))
    }
  }


  displayClassesStateSwitch = () => {
    const { t } = this.props
    return (
      <button
        className='d-flex justify-content-center align-items-center switchButton'
        onClick={() => this.setState({ activeProgramsSelected: !this.state.activeProgramsSelected })}
      >
        <div
          className={`switchOption ${this.state.activeProgramsSelected && 'switchSelected'}`}
        >
          {t('announcements.campaign.status.active')}
        </div>
        <div
          className={`switchOption ${!this.state.activeProgramsSelected && 'switchSelected'}`}
        >
          {t('announcements.campaign.status.completed')}
        </div>
      </button>
    )
  }

  render() { // eslint-disable-line max-lines-per-function
    // const { isEmail, messageTypeSelected } = this.state
    const { t } = this.props
    return (
      <div id='CampaignPage'>
        <Wizard ref={this.wizard}>
          <Steps>
            {/*<Step
              id='Template'
              render={({ next }) => (
                <div className='row d-flex full-height flex-column justify-content-between'>
                  <div className='bg-white w-100 py-4 message-page-header'>
                    <div className='row flex-column animated fadeInDown'>
                      <strong className='d-block'>
                        <h1 className='text-center text-primary display-3'>
                          Please select your message type
                        </h1>
                      </strong>
                      <h4 className='text-center'>
                        Choose to send as an email or post an announcement
                      </h4>
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='row px-md-5'>
                      <div className='col-md-6'>
                        <div className='container'>
                          <button
                            className={`card message-template-card ${
                              this.state.messageTypeSelected === 'email'
                                ? 'active-template-card'
                                : ''
                            }`}
                            onClick={
                              isEmail && messageTypeSelected === 'email'
                                ? next()
                                : () => this.messageTypeSelector('email', next)
                            }
                          >
                            <i
                              className='fa fa-envelope-o message-template-icon'
                              aria-hidden='true'
                            />
                            <h3 className='message-template-title'>Email</h3>
                            <h5 className='message-template-desc'>
                              Send a descriptive message to inform your members
                            </h5>
                          </button>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='container'>
                          <button
                            className={`card message-template-card ${
                              this.state.messageTypeSelected === 'push'
                                ? 'active-template-card'
                                : ''
                            }`}
                            onClick={
                              !isEmail && messageTypeSelected === 'push'
                                ? next()
                                : () => this.messageTypeSelector('push', next)
                            }
                          >
                            <i
                              className='fa fa-bullhorn message-template-icon'
                              aria-hidden='true'
                            />
                            <h3 className='message-template-title'>
                              Post Announcement
                            </h3>
                            <h5 className='message-template-desc'>
                              Send a quick alert to the feed of classes only
                            </h5>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            /> */}

            <Step
              id='Recipients'
              // eslint-disable-next-line complexity
              render={({ next, previous: _ }) => ( // eslint-disable-line max-lines-per-function
                <div className='row d-flex full-height flex-column justify-content-between'>
                  <div className='bg-white w-100 py-4 message-page-header'>
                    <div className='row flex-column animated fadeInDown'>
                      <strong className='d-block'>
                        <h1 className='text-center text-primary display-3'>
                          {this.state.isEmail
                            ? t('announcements.campaign.chooseEmailRecipients')
                            : t('announcements.campaign.chooseAnnouncementRecipients')}
                        </h1>
                      </strong>
                      <h4 className='text-center'>
                        {this.state.messageTypeSelected === 'email'
                          ? t('announcements.campaign.recipientGreetingEmail', { name: this.props.user.first_name })
                          : t('announcements.campaign.recipientGreetingAnnouncement', { name: this.props.user.first_name })}
                      </h4>
                    </div>
                  </div>
                  <div className='col-12'>
                    <div className='row px-md-5'>
                      <div className='col-md-6'>
                        <div className='form-group'>
                          {this.state.messageTypeSelected === 'email' ? (
                            <Tabs onSelect={(e) => this.loadTabs(e)}>
                              <TabList className='d-flex justify-content-center'>
                                <Tab>{t('announcements.campaign.addAClass')}</Tab>
                                <Tab>{t('announcements.campaign.addAFamily')}</Tab>
                                <Tab>{t('announcements.campaign.addAStudent')}</Tab>
                              </TabList>

                              <TabPanel className='bg-white search-result-container'>
                                <div className='border p-2'>
                                  <div className='row my-4'>
                                    <div className='col-12'>
                                      <div className='header-container'>
                                        <h3>{t('announcements.campaign.classes')}</h3>
                                        {this.displayClassesStateSwitch()}
                                        <div className='search-container'>
                                          <i
                                            className='fa fa-search search-icon'
                                            style={{ color: 'lightgrey' }}
                                          />
                                          <SearchInput
                                            className='search-input'
                                            onChange={this.searchPrograms}
                                            style={{
                                              border: '1px solid lightgrey',
                                              borderRadius: '25px',
                                              paddingLeft: '10px',
                                              paddingRight: '10px',
                                              width: '250px',
                                            }}
                                            placeholder={t('announcements.campaign.searchClasses')}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='campaign-result-container container border'>
                                    {this.displayPrograms()}
                                  </div>
                                </div>
                              </TabPanel>

                              <TabPanel className='bg-white search-result-container'>
                                <div className='border p-2'>
                                  <div className='row my-4'>
                                    <div className='col-12'>
                                      <div className='header-container'>
                                        <h3>{t('announcements.campaign.families')}</h3>
                                        {!this.state.familyLoader ? (
                                          <div className='toggle-container animated fadeIn'>
                                            {this.state.selectedAllFamily ? (
                                              <i
                                                className='fa fa-toggle-on family-toggleon-icon'
                                                style={{ color: '#FF6633' }}
                                                aria-hidden='true'
                                                onClick={this.toggleSelectedAllFamily}
                                              />
                                            ) : (
                                              <i
                                                className='fa fa-toggle-off family-toggleoff-icon'
                                                style={{ color: 'lightgrey' }}
                                                aria-hidden='true'
                                                onClick={this.toggleSelectedAllFamily}
                                              />
                                            )}

                                            <p>{t('announcements.common.selectAll')}</p>
                                          </div>
                                        ) : null}

                                        <div className='search-container'>
                                          <i
                                            className='fa fa-search search-icon'
                                            style={{ color: 'lightgrey' }}
                                          />
                                          <SearchInput
                                            className='search-input'
                                            onChange={this.searchFamilies}
                                            style={{
                                              border: '1px solid lightgrey',
                                              borderRadius: '25px',
                                              paddingLeft: '10px',
                                              paddingRight: '10px',
                                              width: '250px',
                                            }}
                                            placeholder={t('announcements.campaign.searchFamilies')}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='campaign-result-container container border'>
                                    {this.displayFamilies()}
                                  </div>
                                </div>
                              </TabPanel>

                              <TabPanel className='bg-white search-result-container'>
                                <div className='border p-2'>
                                  <div className='row my-4'>
                                    <div className='col-12'>
                                      <div className='header-container'>
                                        <h3>{t('announcements.campaign.students')}</h3>
                                        <div className='search-container'>
                                          <i
                                            className='fa fa-search search-icon'
                                            style={{ color: 'lightgrey' }}
                                          />
                                          <SearchInput
                                            className='search-input'
                                            onChange={this.searchStudents}
                                            style={{
                                              border: '1px solid lightgrey',
                                              borderRadius: '25px',
                                              paddingLeft: '10px',
                                              paddingRight: '10px',
                                              width: '250px',
                                            }}
                                            placeholder={t('announcements.campaign.searchStudents')}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='campaign-result-container container border'>
                                    {this.displayStudents()}
                                  </div>
                                </div>
                              </TabPanel>
                            </Tabs>
                          ) : (
                            <div className='bg-white search-result-container border p-2'>
                              <div className='row my-4'>
                                <div className='col-12'>
                                  <div className='header-container'>
                                    <h3>{t('announcements.campaign.classes')}</h3>
                                    {this.displayClassesStateSwitch()}
                                    <div className='search-container'>
                                      <i
                                        className='fa fa-search search-icon'
                                        style={{ color: 'lightgrey' }}
                                      />
                                      <SearchInput
                                        className='search-input'
                                        onChange={this.searchPrograms}
                                        style={{
                                          border: '1px solid lightgrey',
                                          borderRadius: '25px',
                                          paddingLeft: '10px',
                                          paddingRight: '10px',
                                          width: '250px',
                                        }}
                                        placeholder={t('announcements.campaign.searchClasses')}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='campaign-result-container container border'>
                                {this.displayPrograms()}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className={`col-md-6 ${
                          this.state.messageTypeSelected === 'email'
                            ? 'recipient-container'
                            : ''
                        }`}
                      >
                        <div
                          className={`bg-white border p-2 ${
                            this.state.messageTypeSelected === 'email'
                              ? 'mt-4'
                              : ''
                          }`}
                        >
                          <h3>{t('announcements.campaign.recipients')}</h3>
                          {this.state.recipients.length > MAX_EMAIL_LIMIT &&
                            <div className='d-flex my-3 recipients-limit-warning'>
                              <div className='px-3'>
                                <AnnouncementIcon className='announcement-icon' />
                              </div>
                              <div>
                                <p className='warning-title'>{t('announcements.campaign.limitWarningTitle')}</p>
                                <p className='warning-description'>
                                  <Trans
                                    i18nKey='announcements.campaign.limitWarningDescription'
                                    components={{ b: <b /> }}
                                    values={{ count: this.state.recipients.length, limit: MAX_EMAIL_LIMIT }}
                                  />
                                </p>
                                <p className='warning-link' onClick={this.navigateToFeedAnnouncements} aria-hidden='true'>
                                  {t('announcements.campaign.switchToAnnouncement')} <i className='fa fa-arrow-right' aria-hidden='true'></i>
                                </p>
                              </div>
                            </div>
                          }
                          <div
                            className={`recipient-list-wrapper ${
                              this.state.recipients.length > 0 ||
                              this.state.courses.length > 0
                                ? ''
                                : 'mt-5'
                            }`}
                          >
                            {this.state.recipients.length > 0 ||
                            this.state.courses.length > 0 ? (
                                this.displayRecipients()
                              ) : (
                                <Placeholder
                                  title={
                                    this.state.isEmail
                                      ? t('announcements.campaign.noRecipientsEmail')
                                      : t('announcements.campaign.noRecipientsAnnouncement')
                                  }
                                  icon={
                                    this.state.messageTypeSelected === 'email'
                                      ? 'fa-envelope-o'
                                      : 'fa-bullhorn'
                                  }
                                  subtext1={
                                    t('announcements.campaign.startAddingRecipients')
                                  }
                                />
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='fixed-bottom bg-white p-3 text-center'>
                    <button
                      className='btn btn-primary'
                      style={{ width: '40%' }}
                      onClick={next}
                      disabled={
                        this.state.recipients.length > 0 && this.state.recipients.length <= MAX_EMAIL_LIMIT
                          ? false
                          : true
                      }
                    >
                      {this.state.recipients.length > 0 ||
                      this.state.courses.length > 0
                        ? t('common.flow.next')
                        : t('announcements.campaign.addRecipients')}
                    </button>
                  </div>
                </div>
              )}
            />

            <Step
              id='MessageTemplate'
              render={({ previous }) => (
                <div className='row d-flex full-height flex-column justify-content-between '>
                  <div className='bg-white w-100 py-4 message-page-header'>
                    {this.state.isEmail ? (
                      <div
                        className={`row flex-column animated ${
                          this.state.isEmail ? 'fadeInDown' : 'fadeOutUp'
                        }`}
                      >
                        <strong className='d-block'>
                          <h1 className='text-center text-primary display-3'>
                            {t('announcements.campaign.createEmailTitle')}
                          </h1>
                        </strong>
                        <h4 className='text-center'>
                          {t('announcements.campaign.sendingAsEmail')}
                        </h4>
                      </div>
                    ) : (
                      <div
                        className={`row flex-column animated ${
                          !this.state.isEmail ? 'fadeInDown' : 'fadeOutUp'
                        }`}
                      >
                        <strong className='d-block'>
                          <h1 className='text-center text-primary display-3'>
                            {t('announcements.campaign.createAnnouncementTitle')}
                          </h1>
                        </strong>
                        <h4 className='text-center'>
                          {t('announcements.campaign.sendingAsAnnouncement')}
                        </h4>
                      </div>
                    )}
                  </div>

                  <div className='col-12'>
                    {this.state.messageTypeSelected === 'email' ? (
                      <div className='row email-template-row'>
                        <div className='col-6'>
                          <h3>{t('announcements.campaign.templatesHeading')}</h3>
                          <select
                            className='custom-select custom-select-lg mb-3'
                            onChange={this.onTemplateChange}
                            value={this.state.templateValue}
                          >
                            <option value={0}>{t('announcements.campaign.chooseTemplate')}</option>
                            <option value={1}>
                              {t('announcements.campaign.templateOption1')}
                            </option>
                            <option value={2}>
                              {t('announcements.campaign.templateOption2')}
                            </option>
                            <option value={3}>
                              {t('announcements.campaign.templateOption3')}
                            </option>
                            <option value={4}>{t('announcements.campaign.templateOption4')}</option>
                            <option value={5}>{t('announcements.campaign.templateOption5')}</option>
                            <option value={6}>{t('announcements.campaign.templateOption6')}</option>
                          </select>
                          <div className='mb-3'>
                            <label htmlFor='subject'>{t('announcements.campaign.subject')}</label>
                            <TextInput
                              name='Subject'
                              type='text'
                              label=''
                              onChange={this.onChangeSubject}
                              placeholder={t('announcements.campaign.enterSubject')}
                              value={this.state.subject}
                            />
                          </div>
                          {this.renderEditor()}
                        </div>
                        <div className='col-6 bg-dark p-4'>
                          <h3 className='text-white mt-3'>{t('announcements.campaign.preview')}</h3>
                          <div className='card my-4 p-4'>
                            <img
                              src={
                                this.props.user.communities.length > 0
                                  ? this.props.user.communities[0].photo.file_url
                                  : coachLogo
                              }
                              className={`my-3 mx-auto ${
                                this.props.user.communities.length > 0
                                  ? 'preview-community-logo'
                                  : ''
                              }`}
                              alt={t('announcements.campaign.communityLogoAlt')}
                            />
                            {/* <img src={sampleImage} className="w-100" /> */}
                            <div
                              dangerouslySetInnerHTML={this.createMarkup()}
                            />
                            <div className='mt-5'>
                              <p className='mb-3'>{t('announcements.campaign.sincerely')}</p>
                              <p className='mb-1'>
                                {this.props.user.first_name}{' '}
                                {this.props.user.last_name}
                              </p>
                              <p>{this.props.user.email}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='row'>
                        <div className='col-6'>
                          <h3>{t('announcements.campaign.textEditor')}</h3>
                          <TextAreaInput
                            name='Message'
                            type='text'
                            rows='3'
                            label=''
                            maxLength='120'
                            onChange={this.onChangePushMessage}
                            placeholder={t('announcements.campaign.typeYourMessage')}
                            value={this.state.pushMessage}
                          />
                          <small
                            style={{
                              color:
                                this.state.pushMessageLength === 120
                                  ? '#33d9b2'
                                  : '',
                            }}
                          >
                            {this.state.pushMessageLength === 120
                              ? t('announcements.campaign.characterLimitReached')
                              : t('announcements.campaign.charactersLeft', { remaining: 120 - this.state.pushMessageLength })}
                          </small>
                        </div>
                        <div className='col-6 bg-dark'>
                          <h3 className='text-white mt-3'>{t('announcements.campaign.preview')}</h3>
                          <div className='ios-notification mb-3'>
                            <div className='ios-notification-header'>
                              <h3 className='ios-notification-header-title'>
                                Op36 App
                              </h3>
                              <h3 className='ios-notification-header-time'>
                                {t('announcements.campaign.now')}
                              </h3>
                            </div>
                            <div className='p-2'>
                              <p>{this.state.pushMessage}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className=' fixed-bottom bg-white p-3'>
                    <div className='row'>
                      <div className='col-6'>
                        <button
                          className='mx-auto w-100 btn btn-dark'
                          onClick={previous}
                        >
                          {t('announcements.campaign.changeRecipients')}
                        </button>
                      </div>
                      <div className='col-6'>
                        <button
                          className='mx-auto btn-block btn btn-primary'
                          onClick={this.sendPressed}
                        >
                          <i className='fas fa fa-paper-plane' /> {t('announcements.campaign.review')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            />
          </Steps>
        </Wizard>
        <StudentModal
          toggleModal={this.toggleModal}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          students={this.state.students}
          isFamily={this.state.isFamily}
        />
        <PreviewModal
          closeModal={this.closePreviewModal}
          showModal={this.state.showPreviewModal}
          subject={this.state.subject}
          message={this.state.message}
          pushMessage={this.state.pushMessage}
          sendMessage={this.sendMessage}
          recipients={this.state.recipients}
          courses={this.state.courses}
          isEmail={this.state.isEmail}
          loader={this.state.emailLoader}
        />
        <ValidationModal
          validationSuccess={this.state.validationSuccess}
          showValidationModal={this.state.showValidationModal}
          closeValidationModal={this.closeValidationModal}
          validationMessage={this.state.validationMessage}
        />
      </div>
    )
  }
}

Campaign.propTypes = {
  t: PropTypes.func,
  label: PropTypes.string,
  checked: PropTypes.bool,
  imageURL: PropTypes.string,
  family_actions: PropTypes.shape({
    getFamilies: PropTypes.func,
  }),
  community_actions: PropTypes.shape({
    getAllStudents: PropTypes.func,
  }),
  user_actions: PropTypes.shape({
    getAnnouncementCourses: PropTypes.func,
  }),
  announcement_actions: PropTypes.shape({
    postWebEmail: PropTypes.func,
  }),
  activity_actions: PropTypes.shape({
    postWebActivityAnnouncement: PropTypes.func,
  }),
  courses: PropTypes.array,
  families: PropTypes.array,
  community_students: PropTypes.array,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    communities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      photo: PropTypes.shape({
        file_url: PropTypes.string,
      }),
    })),
  }),
  location: PropTypes.shape({
    state: PropTypes.shape({
      smartToggle: PropTypes.string,
      students: PropTypes.array,
    }),
  }),
  navigate: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    // ui: state.ui,
    // ranks: state.ranks,
    user: state.user.current_user,
    family: state.family,
    families: state.families,
    courses: state.courses.courses,
    completed_courses: state.courses.completed_courses,
    community_students: state.communityStudents?.students,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    // actions: bindActionCreators(rankActions, dispatch),
    // common_actions: bindActionCreators(commonActions, dispatch),
    user_actions: bindActionCreators(userActions, dispatch),
    family_actions: bindActionCreators(familyActions, dispatch),
    community_actions: bindActionCreators(communitiesActions, dispatch),
    announcement_actions: bindActionCreators(announcementsActions, dispatch),
    activity_actions: bindActionCreators(activityActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouting(Campaign)))
